import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profilesuccess',
  templateUrl: './profilesuccess.component.html',
  styleUrls: ['./profilesuccess.component.css']
})
export class ProfilesuccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Joey/Desktop/testdeploy/mk2/FindMeHireMe/src/app/profilesuccess/profilesuccess.component.ts